import D2C_Instance from '../Instance'

class D2C_InstanceDO extends D2C_Instance {
  static active = true
  static objectType = 'instanceType'
  static providerType = 'DO'
  get _title() {
    const types = {m: 'Mem-optimized', s: 'Basic', c: 'CPU-optimized'};
    const type = this.id.substr(0, 1);
    return `${types[type]}, ${this.memory}GB RAM, ${this.cores} vCPU`
  }
}

export default D2C_InstanceDO
